{
  "name": "@lekto/platform",
  "version": "3.0.0",
  "description": "Lekto - Plataforma",
  "private": true,
  "scripts": {
    "build": "nx build platform",
    "serve": "nx serve platform",
    "test": "nx test platform",
    "lint": "nx lint platform"
  }
}
